import React from "react"
import Slideshow from "../components/Slider"
import styles from '../styles/landing.module.css'
import { Link } from 'react-router-dom'
import Nav from '../components/NavBar'


export default function Landing() {
    return (
        <div className={styles.container_landing}>
            <Nav />
            <div className={styles.content_landing}>
                <div className={styles.first_landing}>
                    <div className={styles.descript_landing}>
                        <h1>Dog Breeds App</h1>
                        <p className={styles.descript_p}>
                            Dog breeds is an application where you can find different breeds
                            of dogs, you can create your own breeds.
                        </p>
                        <span>Come on I invite you to see the app</span>
                        <div className={styles.btn_landing}>
                            <div className={styles.btn_home_landing}>
                                <Link to={'/Home'}>
                                    <span className={styles.enter_out}>enter</span>
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className={styles.slider_landing}>
                        <Slideshow className={styles.sli_landing} />
                    </div>
                </div>
            </div>
        </div>
    )
}